"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var INBOUNDDB_QUOTE_EXPORT_URL = 'inbounddbquotes/v1/exports';

var QuotesAPI =
/*#__PURE__*/
function () {
  function QuotesAPI() {
    (0, _classCallCheck2.default)(this, QuotesAPI);
  }

  (0, _createClass2.default)(QuotesAPI, null, [{
    key: "startExport",
    value: function startExport() {
      return _apiClient.default.post(INBOUNDDB_QUOTE_EXPORT_URL);
    }
  }]);
  return QuotesAPI;
}();

exports.default = QuotesAPI;
module.exports = exports.default;